<template>
	<section>
		<v-card elevation="2" rounded="xl">
			<div class="sp-header">
				<div class="sp-header-left">
					<div class="sp-icon-box">
						<v-icon size="18" color="white">mdi-account-heart</v-icon>
					</div>
					<div>
						<p class="sp-title">Parrainages</p>
						<p class="sp-subtitle">Relations parrain / filleul</p>
					</div>
				</div>
				<v-text-field
					v-model="search"
					prepend-inner-icon="mdi-magnify"
					placeholder="Rechercher..."
					outlined
					dense
					hide-details
					class="sp-search"
					color="blue darken-2"
				></v-text-field>
			</div>

			<v-divider></v-divider>

			<v-data-table
				:headers="headers"
				:items="customers"
				:server-items-length="totalItems"
				:options.sync="options"
				:loading="loading"
				loading-text="Chargement en cours..."
				class="sp-table"
				:footer-props="{
					'items-per-page-options': [10, 25, 50],
					'items-per-page-text': 'Lignes par page',
					'items-per-page-all-text': 'Tout',
				}"
			>
				<template v-slot:[`item.index`]="{ index }">
					<span class="sp-index"># {{ (options.page - 1) * (options.itemsPerPage || 10) + index + 1 }}</span>
				</template>

				<template v-slot:[`item.godFather`]="{ item }">
					<span>{{ item.godFather.fullName }}</span>
				</template>

				<template v-slot:[`item.arrow`]>
					<v-icon size="15" color="#d1d5db">mdi-arrow-right</v-icon>
				</template>

				<template v-slot:[`item.fullName`]="{ item }">
					<span>{{ item.fullName }}</span>
				</template>

				<template v-slot:[`footer.page-text`]="items">
					{{ items.pageStart }}-{{ items.pageStop }} sur {{ items.itemsLength }}
				</template>
				<template v-slot:no-data>
					<v-btn text color="primary" @click="initialize">Actualiser</v-btn>
				</template>
			</v-data-table>
		</v-card>
	</section>
</template>

<script>
import service from "../services";
export default {
	data() {
		return {
			loading: false,
			search: "",
			searchTimeout: null,
			options: {},
			totalItems: 0,
			customers: [],
			headers: [
				{ text: "N°", value: "index", sortable: false, width: "60px" },
				{ text: "Parrain", value: "godFather", sortable: false },
				{ text: "", value: "arrow", sortable: false, width: "40px" },
				{ text: "Filleul", value: "fullName", sortable: false },
			],
		};
	},
	watch: {
		options: {
			handler() { this.initialize(); },
			deep: true,
		},
		search() {
			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => {
				if (this.options.page !== 1) {
					this.options.page = 1;
				} else {
					this.initialize();
				}
			}, 400);
		},
	},
	methods: {
		initialize() {
			this.loading = true;
			const page = this.options.page || 1;
			const limit = this.options.itemsPerPage || 10;
			service.getSponsorshipsPaginated({ page, limit, search: this.search })
				.then((r) => {
					if (Array.isArray(r.data)) {
						this.customers = r.data;
						this.totalItems = r.data.length;
					} else {
						this.customers = r.data.sponsorships || [];
						this.totalItems = (r.data.totalPages || 1) * limit;
					}
					this.loading = false;
				})
				.catch((e) => { console.log(e); this.loading = false; });
		},
	},
};
</script>

<style scoped>
.sp-header { display: flex; align-items: center; padding: 18px 20px 14px; gap: 14px; flex-wrap: wrap; }
.sp-header-left { display: flex; align-items: center; gap: 14px; flex: 1; min-width: 200px; }
.sp-icon-box { width: 38px; height: 38px; border-radius: 10px; background: linear-gradient(135deg, #c62828, #b71c1c); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.sp-title { font-size: 0.92rem; font-weight: 700; color: #111827; margin: 0 0 2px; font-family: Montserrat, sans-serif; }
.sp-subtitle { font-size: 0.72rem; color: #9ca3af; margin: 0; font-family: Montserrat, sans-serif; }
.sp-search { max-width: 260px; }
.sp-table { font-family: Montserrat, sans-serif; }
.sp-index { font-size: 0.75rem; font-weight: 600; color: #9ca3af; font-family: Montserrat, sans-serif; }
</style>
